// Column definitions + localStorage persistence for the IT 備品・資産 tables.
// Two independent configs — durable (資産) and consumable (消耗品) — because
// they have very different columns.
import { makeColumnPrefs } from '@/lib/tableColumnPrefs';

const DURABLE_LS = 'it_assets_cols_durable_v1';
const CONSUMABLE_LS = 'it_assets_cols_consumable_v1';

// order = default column order. fixed:true → always shown, cannot be hidden.
export const DURABLE_COLUMN_DEFS = [
  { key: 'asset_tag', label: '資産番号', defaultOn: true },
  { key: 'name', label: '品名', defaultOn: true, fixed: true }, // primary
  { key: 'category', label: 'カテゴリ', defaultOn: true },
  { key: 'status', label: '状態', defaultOn: true },
  { key: 'assigned_to_name', label: '使用者', defaultOn: true },
  { key: 'book_value', label: '簿価', defaultOn: true },
];

export const CONSUMABLE_COLUMN_DEFS = [
  { key: 'name', label: '品名', defaultOn: true, fixed: true },
  { key: 'category', label: 'カテゴリ', defaultOn: true },
  { key: 'location', label: '保管場所', defaultOn: true },
  { key: 'on_hand_qty', label: '在庫', defaultOn: true },
  { key: 'reorder_point', label: '発注点', defaultOn: true },
  { key: 'low_stock', label: '状態', defaultOn: true },
];

export const durableCols = makeColumnPrefs(DURABLE_COLUMN_DEFS, DURABLE_LS);
export const consumableCols = makeColumnPrefs(CONSUMABLE_COLUMN_DEFS, CONSUMABLE_LS);
